import { TbBuildingFactory } from "react-icons/tb";
import {
  RiCloseCircleLine,
  RiMoneyDollarCircleLine,
  RiPauseCircleLine,
  RiShip2Line,
  RiSubtractLine,
  RiTruckLine,
} from "react-icons/ri";
import { BiMapPin } from "react-icons/bi";

export const SHIPMENT_STATUSES = [
  "waiting for deposit payment",
  "in production",
  "delivered to port",
  "shipping",
  "arrived at destination",
  "on hold",
  "canceled",
  "-",
];

function ShipmentStatus({
  className = "",
  status,
  iconOnly = false,
  tooltip = false,
}) {
  let icon = null;
  let showIcon = false;
  let textColor = "text-gray-700";
  switch (status) {
    case "waiting for deposit payment":
      icon = <RiMoneyDollarCircleLine size={21} />;
      showIcon = true;
      textColor = "text-yellow-600";
      break;
    case "in production":
      icon = <TbBuildingFactory size={21} />;
      showIcon = true;
      textColor = "text-green-500";
      break;
    case "delivered to port":
      icon = <RiTruckLine size={21} />;
      showIcon = true;
      textColor = "text-indigo-500";
      break;
    case "shipping":
      icon = <RiShip2Line size={21} />;
      showIcon = true;
      textColor = "text-purple-600";
      break;
    case "arrived at destination":
      icon = <BiMapPin size={21} />;
      showIcon = true;
      textColor = "text-teal-600";
      break;
    case "on hold":
      icon = <RiPauseCircleLine size={21} />;
      textColor = "text-pink-500";
      break;
    case "canceled":
      icon = <RiCloseCircleLine size={21} />;
      textColor = "text-red-500";
      break;
    case "-":
      icon = <RiSubtractLine size={21} />;
      textColor = "text-gray-500";
      break;
    default:
      break;
  }
  return (
    <div
      className={`${className} ${textColor} ${tooltip ? "group relative" : ""} flex items-center`}
      title={iconOnly && !tooltip ? status : undefined}
      aria-label={iconOnly ? status : undefined}
    >
      {(showIcon || iconOnly) && icon}
      {!iconOnly && (
        <span className="ml-2 whitespace-nowrap capitalize">{status}</span>
      )}
      {tooltip && (
        <span
          role="tooltip"
          className="pointer-events-none absolute bottom-full left-1/2 z-20 mb-1 -translate-x-1/2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white opacity-0 group-hover:opacity-100 dark:bg-gray-100 dark:text-gray-900"
        >
          {status}
        </span>
      )}
    </div>
  );
}

export default ShipmentStatus;
